let welcomeMatKey;

export function shouldShowWelcomeMat(name) {
  welcomeMatKey = `welcomeMat.${name}.dismissed`;
  return (
    !Boolean(localStorage.getItem(welcomeMatKey)) &&
    !Boolean(sessionStorage.getItem(welcomeMatKey))
  );
}

export function close(name) {
  welcomeMatKey = `welcomeMat.${name}.dismissed`;
  return new Promise(resolve => {
    sessionStorage.setItem(welcomeMatKey, 1);
    resolve();
  });
}

export function update(shouldOpen, name) {
  welcomeMatKey = `welcomeMat.${name}.dismissed`;
  return new Promise(resolve => {
    if (shouldOpen) {
      localStorage.removeItem(welcomeMatKey);
    } else {
      localStorage.setItem(welcomeMatKey, 1);
    }
    resolve();
  });
}
